import { DefaultSeo } from 'next-seo';
import {
  Bodoni_Moda,
  Noto_Sans,
  Noto_Sans_TC,
  Rubik,
  Zen_Maru_Gothic,
} from 'next/font/google';
import React from 'react';
import { UAParser } from 'ua-parser-js';
// import Header from 'components/Header';

// import api from 'utils/api';
import { useRouter } from 'next/router';
import { SWRConfig } from 'swr';

import { AppLaunchProvider } from 'contexts/AppLaunch';
import { FirebaseAuthProvider } from 'contexts/FirebaseAuth';
import { GlobalConfigProvider } from 'contexts/GlobalConfig';
import { UserAuthProvider } from 'contexts/UserAuth';
import { UserDataProvider } from 'contexts/UserData';
import { GroupBuyCartProvider } from 'contexts/GroupBuyCart';
import Script from 'next/script';
import Modal from 'react-modal';
import SEO from 'utils/next-seo.config';
import { LaunchDataProvider } from '../contexts/LaunchData';

import AddToHomeModal from 'components/AddToHomeModal';
import BaseInfoReminderModal from 'components/BaseInfoReminderModal';
import PageLayout from 'components/PageLayout';
import RatingModal from 'components/RatingModal';
import AppDownloadModal from 'components/AppDownloadModal';
import { useUTMCapture } from 'hooks/useUTMCapture';

import Justfont from 'utils/Justfont';

export const notoSans = Noto_Sans({
  weight: ['300', '400', '500', '600', '700', '800'],
  subsets: ['latin'],
  variable: '--font-noto-sans',
});

export const notoSansTC = Noto_Sans_TC({
  weight: ['300', '400', '500', '600', '700'],
  subsets: ['latin'],
  variable: '--font-noto-sans-tc',
});

export const rubik = Rubik({
  weight: ['300', '400', '500', '600', '700'],
  subsets: ['latin'],
  variable: '--font-rubik',
});

export const bodoniModa = Bodoni_Moda({
  weight: ['400', '500', '600', '700'],
  subsets: ['latin'],
  variable: '--font-bodoni-moda',
});

export const zenMaruGothic = Zen_Maru_Gothic({
  weight: ['300', '400', '500', '700', '900'],
  subsets: ['latin'],
  variable: '--font-zen-maru-gothic',
});

import 'styles/globals.css';
import 'styles/index.css';
import 'styles/menubar.css';
import 'styles/override.css';
import 'styles/ranking.css';
import 'styles/react-responsive-carousel-override.css';
import 'styles/register/registerPopup.css';
import 'styles/rewards.css';
import 'styles/search.css';

import { GoogleAnalyticsTracking } from 'utils/GoogleAnalyticsTracking';
import { trackPageView } from 'utils/ga';

const { useState, useEffect } = React;

export default function App({ Component, pageProps }) {
  const { asPath } = useRouter();
  const [UA, setUA] = useState(null);

  useUTMCapture();

  useEffect(() => {
    Modal.setAppElement('#app-wrapper');
    const userAgent = window.navigator.userAgent;
    setUA(UAParser(userAgent));
  }, []);
  useEffect(() => {
    document.querySelector('#app-wrapper').scrollTo(0, 0);
    document.querySelector('#app-wrapper').style.overflow = '';
    try {
      if (typeof window !== 'undefined' && window._jf) {
        if (window._jf && window._jf.flush) {
          window._jf.flush();
        }
      }
    } catch (e) {}
  }, [asPath]);

  // 只取 pathname（去掉 query 與 hash），讓「同頁只換 query」不會重送 page_view
  // 換頁（pathname 變化）才手動送 GA page_view；產品／品牌／評價頁的 pageProps
  const gaPathname = asPath.split('?')[0].split('#')[0];
  useEffect(() => {
    const { gaBrandId, gaProductId, gaProductName } = pageProps || {};
    const params = {};
    if (gaBrandId != null && gaBrandId !== '')
      params.brand_id = String(gaBrandId);
    if (gaProductId != null && gaProductId !== '')
      params.product_id = String(gaProductId);
    if (gaProductName) params.product_name = String(gaProductName);
    trackPageView(params);
  }, [gaPathname]);

  return (
    <GlobalConfigProvider
      fonts={{
        notoSans,
        notoSansTC,
        rubik,
      }}
      UA={UA}
    >
      <DefaultSeo {...SEO} />
      <Justfont />
      <style jsx global>{`
        :root {
          --font-jinxuanlatte: 'jf-jinxuanlatte';
          --font-noto-sans: ${notoSans.style.fontFamily};
          --font-noto-sans-tc: ${notoSansTC.style.fontFamily};
          --font-rubik: ${rubik.style.fontFamily};
          --font-bodoni-moda: ${bodoniModa.style.fontFamily};
          --font-zen-maru-gothic: ${zenMaruGothic.style.fontFamily};
        }
      `}</style>
      <Script
        async
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7575047962123456"
        crossOrigin="anonymous"
        strategy="afterInteractive"
      />
      <div
        id="app-wrapper"
        className="h-full w-full overflow-y-auto"
        // className={`h-full w-full overflow-y-auto ${notoSans.variable} ${notoSansTC.variable} ${rubik.variable} ${bodoniModa.variable}`}
      >
        <div className="relative font-sans">
          <SWRConfig
            value={{
              revalidateOnFocus: true,
            }}
          >
            <GoogleAnalyticsTracking />
            <AppLaunchProvider>
              <LaunchDataProvider>
                <FirebaseAuthProvider>
                  <UserAuthProvider>
                    <UserDataProvider>
                      <GroupBuyCartProvider>
                        <PageLayout>
                          <Component {...pageProps} />
                        </PageLayout>
                        <AddToHomeModal />
                        <RatingModal />
                        <BaseInfoReminderModal />
                        <AppDownloadModal />
                      </GroupBuyCartProvider>
                    </UserDataProvider>
                  </UserAuthProvider>
                </FirebaseAuthProvider>
              </LaunchDataProvider>
            </AppLaunchProvider>
          </SWRConfig>
        </div>
      </div>
    </GlobalConfigProvider>
  );
}
